import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import {Upload, Modal, message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker   } from 'antd';
import { LoadingOutlined,PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined,FilePdfOutlined } from '@ant-design/icons';
import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';
import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';
import license from '../../assets/images/icon/license.png';
const dateFormat = 'YYYY-MM-DD';
const buttonWidth = 70;
function callback(key) {
console.log(key);
}
function getBase64(file) {
return new Promise((resolve, reject) => {
const reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = () => resolve(reader.result);
reader.onerror = error => reject(error);
});
}
function getBase64_(img, callback) {
const reader = new FileReader();
reader.addEventListener('load', () => callback(reader.result));
reader.readAsDataURL(img);
}
function beforeUpload(file) {
const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
if (!isJpgOrPng) {
message.error('You can only upload JPG/PNG file!');
}
const isLt2M = file.size / 1024 / 1024 < 2;
if (!isLt2M) {
message.error('Image must smaller than 2MB!');
}
return isJpgOrPng && isLt2M;
}
const storedFiles=[];
const storedFilespdf=[];
const storedFilespdf2=[];
class Index extends React.Component {
static contextTypes = {
router: () => null
};
constructor(props) {
super(props);
this.state = {
size: 'default',
previewVisible: false,
previewImage: '',
previewTitle: '',
imageUrl: '',
fileList: [],
loading: false,
name: '',
mobile: '',
licence: '',
aadhar_card_no: '',
address: '',
loading: false,
iconLoading: false,
file_list: [],
file_list_pdf: [],
file_list_pdf_2: [],
file1:null,
school_list:[],
id: this.props.match.params.id,
}
this.onChangebirthday = this.onChangebirthday.bind(this);	
}
componentWillMount() {
document.querySelector(".loader-wrapper").style = "display: none";
setTimeout(() => {
document.querySelector(".loader-wrapper").style = "display: none";
}, 500);
if(!localStorage.getItem('schoolData')) {
localStorage.setItem("schoolData",'');
localStorage.clear();
window.location.href = '/login';
}else{
var storedArray = JSON.parse(localStorage.getItem("schoolData"))
this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id']});
this.checkData()
}
}
checkData(){
if(localStorage.getItem('schoolData')){
var storedArray = JSON.parse(localStorage.getItem("schoolData"));
this.setState({ user_id : storedArray['data'][0]['user_id'] });
var user_id = storedArray['data'][0]['user_id'];
let program_id = this.props.match.params.id;
var app = {user_id : user_id,id:program_id}
getData('erp/driver_details',app).then((result) => {
let responseJson = result;
if(responseJson.data){
if(result['status'] == 200){
this.setState({
school_list: result['data'],
id: result['data'][0]['id'],
name: result['data'][0]['name'],
mobile: result['data'][0]['mobile'],
licence: result['data'][0]['licence'],
aadhar_card_no: result['data'][0]['aadhar_card_no'],
birthday: result['data'][0]['birthday'],
address: result['data'][0]['address'],
});
}else{
this.setState({
school_list: [],
});
}
}
});
}
}
handleSubmit=(e)=>{
e.preventDefault();
if(localStorage.getItem('schoolData')){
this.setState({ loading: true });
var id = this.state.type
getData('erp/driver_edit',this.state).then((result) => {
if(result.status==400){
message.config({ top: 150});
message.error(result.message, 2);
this.setState({ loading: false });
}
if(result.status==200){		  
message.config({ top: 150});			
const selectedFiles = this.state.file_list;
const selectedFilespdf = this.state.file_list_pdf;	
const selectedFilespdf2 = this.state.file_list_pdf_2;					
const data = new FormData() ;
const image = [] ;
const licence = [] ;
const audio = [] ;
if(selectedFiles.length == 0){
data.append(`image[0]`, '[]')
}
if(selectedFilespdf.length == 0){
data.append(`licence[0]`, '[]')
}
if(storedFilespdf2.length == 0){
data.append(`aadhar[0]`, '[]')
}
for (let i = 0; i < selectedFiles.length; i++) {
data.append(`image[${i}]`, selectedFiles[i].selectedFiles)
}
for (let i = 0; i < selectedFilespdf.length; i++) {
data.append(`licence[${i}]`, selectedFilespdf[i].storedFilespdf)
}		
for (let i = 0; i < selectedFilespdf2.length; i++) {
data.append(`aadhar[${i}]`, selectedFilespdf2[i].storedFilespdf2)
}
data.append('id', result.id)
data.append('user_id', this.state.user_id)			   				
let baseurl;
let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_driver_pic";	
axios.post(url, data, {
})
.then(res => {  
message.config({ top: 150});
message.success('Driver Updated',2);
this.setState({ loading: false });
this.setState({comment_text:''});
window.location.href = '/transport-setup/drivers';
})
//upload images ends	
}
});
}else{
message.error('Please Login',2);	
}
}

handleSizeChange = e => {
this.setState({ [e.target.name]: e.target.value });
	if(e.target.name == 'aadhar_card_no'){
	var pattern =  /^[2-9]\d{11}$/;
		if (pattern.test(e.target.value)) {
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
			document.getElementById("aadhar_card_error").innerHTML = "";
			document.getElementById("submit_btn").disabled = false;
		}else{
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("aadhar_card_error").innerHTML = "Please Enter Valid Aadhar No !!!";
			document.getElementById("submit_btn").disabled = true;
		}
	}

	if(e.target.name == 'mobile'){
		var pattern = new RegExp(/^[0-9\b]+$/);
		if (!pattern.test(e.target.value)) {
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("mobile_error").innerHTML = "Please Enter Only Number !!!";
			document.getElementById("submit_btn").disabled = true;
		}else if(e.target.value.length != 10){
			document.getElementsByName(e.target.name)[0].classList.add("error_focus");
			document.getElementById("mobile_error").innerHTML = "Please Enter Valid Phone Number. !!!";
			document.getElementById("submit_btn").disabled = true;
		}else{
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
			document.getElementById("mobile_error").innerHTML = "";
			document.getElementById("submit_btn").disabled = false;
		}
	}
};



handleCancel = () => this.setState({ previewVisible: false });
handlePreview = async file => {
if (!file.url && !file.preview) {
file.preview = await getBase64(file.originFileObj);
}
this.setState({
previewImage: file.url || file.preview,
previewVisible: true,
previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
});
};
handleChange = info => {
if (info.file.status === 'uploading') {
this.setState({ loading: true });
return;
}
if (info.file.status === 'done') {
// Get this url from response in real world.
getBase64(info.file.originFileObj, imageUrl =>
this.setState({
imageUrl,
loading: false,
}),
);
}
};
handleChange = ({ fileList }) => this.setState({ fileList });
handleFileSelect = (e) =>{
var files = e.target.files;		
var people = [];
var filesArr = Array.prototype.slice.call(files);
filesArr.forEach(function (f) {   
if (storedFiles.length > 3) {
message.config({ top: 150});
message.error('Sorry!..You can upload maximum 10 files at a time',2);
} else {
var _size = f.size;
if (_size > 4100000) {
message.config({ top: 150});
message.error("Sorry!..You Can't Upload more then 4MB!",2);
return false;
}
var reader = new FileReader();
reader.onload = function (e) {
var name = f.type;
var t = name.toString().split('/');
//if (t[0] === 'image') {
var app = {
file_name: f.name,
file_url: e.target.result,					
file_type: 'image',
selectedFiles: f
}
storedFiles.push(app);
people.push(f);
// }				
}
reader.readAsDataURL(f);
}
});
setTimeout(() => {
this.setState({file_list:storedFiles});
}, 500);
} 
removeFile= (file,e) =>{
for (var i = 0; i < storedFiles.length; i++) {
if (storedFiles[i].file_name === file) {
storedFiles.splice(i, 1);
break;
}
}
setTimeout(() => {			
if (storedFiles.length=='0') {
const file = document.querySelector('.file');
//file.value = '';
}			
this.setState({file_list:storedFiles});
//console.log(storedFiles);
}, 500);
}
handleFileSelectpdf = (e) =>{
var files = e.target.files;		
var people = [];
var filesArr = Array.prototype.slice.call(files);
filesArr.forEach(function (f) {   
if (storedFilespdf.length > 3) {
message.config({ top: 150});
message.error('Sorry!..You can upload maximum 10 files at a time',2);
} else {
var _size = f.size;
if (_size > 4100000) {
message.config({ top: 150});
message.error("Sorry!..You Can't Upload more then 4MB!",2);
return false;
}
var reader = new FileReader();
reader.onload = function (e) {
var name = f.type;
var t = name.toString().split('/');
//if (t[0] === 'image') {
var app = {
file_name: f.name,
file_url: e.target.result,					
file_type: 'image',
storedFilespdf: f
}
storedFilespdf.push(app);
people.push(f);
// }				
}
reader.readAsDataURL(f);
}
});
setTimeout(() => {
this.setState({file_list_pdf:storedFilespdf});
}, 500);
} 
handleFileSelectpdf2 = (e) =>{
var files = e.target.files;		
var people = [];
var filesArr = Array.prototype.slice.call(files);
filesArr.forEach(function (f) {   
if (storedFilespdf2.length > 1) {
message.config({ top: 150});
message.error('Sorry!..You can upload maximum 1 files at a time',2);
} else {
var _size = f.size;
if (_size > 4100000) {
	message.config({ top: 150});
	message.error("Sorry!..You Can't Upload more then 4MB!",2);
	return false;
}
var reader = new FileReader();
reader.onload = function (e) {
var name = f.type;
var t = name.toString().split('/');
//if (t[0] === 'image') {
var app = {
file_name: f.name,
file_url: e.target.result,					
file_type: 'image',
storedFilespdf2: f
}
storedFilespdf2.push(app);
people.push(f);
// }				
}
reader.readAsDataURL(f);
}
});
setTimeout(() => {
this.setState({file_list_pdf_2:storedFilespdf2});
}, 500);
} 
removeFilepdf = (file,e) =>{
for (var i = 0; i < storedFilespdf.length; i++) {
if (storedFilespdf[i].file_name === file) {
storedFilespdf.splice(i, 1);
break;
}
}
setTimeout(() => {			
if (storedFilespdf.length=='0') {
const file = document.querySelector('.file');
file.value = '';
}			
this.setState({file_list_pdf:storedFilespdf});
//console.log(storedFilespdf);
}, 500);
}
file_preview1 = (e) => {
let file = e.target.files[0];
if(file.size<=1100000){	
$('#file_preview1').html('1 file selected');
this.setState({ file1: e.target.files[0]});
}
else{
message.config({ top: 150});
message.error('Error! Max file size 1MB allowed!');	
}		
}
onChangebirthday(date, dateString) {
this.setState({ birthday: dateString });
}
render()
{
const { previewVisible, previewImage, fileList, previewTitle } = this.state;
const uploadButton = (
<div>
   <div className="ant-upload-text">Upload</div>
</div>
);
const uploadButton1 = (
<div>
   {this.state.loading ? 
   <LoadingOutlined />
   : 
   <PlusOutlined />
   }
   <div className="ant-upload-text">Upload Profile</div>
</div>
);
const { imageUrl } = this.state;
return (
<div class="mobile_view">
   <div class="row bred">
		<div class="col-md-12">
			<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Edit Driver
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/drivers`} class="router-link-active" target="_self">Driver Profile</a></li>
								<li class="breadcrumb-item"> Edit Driver </li>
							</ol>
						</div>
					</h4>
				</div>
			</div>
		</div>
	</div>
   <div id="main" class="bg-off">
      <div class="row">
         {this.state.school_list.map((list) => (
         <div class="col-md-12 ex-padd">
            <div class="">
               <div class="col-md-12 mb-20 mt-10 card-content iq-card">
                  <section class="invoice-list-wrapper section food">
                     <div class="children mb-20 iq-card2 flow-root form-group">
                        <div class="bb d-flex pb-10">
                           <div class="col-md-2 center  children-add">
                              {(() => {
                              if (this.state.file_list == 0) {
                              return (
                              <>
                              
                                       <ModalImage  small={list.image} large={list.image} hideDownload="true" className="new-pimage" />
                                       <label tabindex="0" class="pointer" role="button" for="image">	
                                       <span class="remove-image">Select Profile Pic</span>	
                                       <input  onChange={this.handleFileSelect} class="file-upload__input file hide" type="file" name="files" id="image" accept="image/*" /> </label>
                                    
                              </>
                              )
                              }else{
                              return (
                              <>
                              {this.state.file_list.map((img) => (
                              <>
                              {(() => {
                              return (
                              <div class="ant-upload-list ant-upload-list-picture-card">
                                 <div class="ant-upload-list-item ant-upload-list-item-done">
                                    <div class="ant-upload-list-item-info">
                                       <ModalImage  small={img.file_url} large={img.file_url} hideDownload="true" />
                                       <button class="change-profile" id='remove' data-file={img.file_name} onClick={this.removeFile.bind(this,img.file_name)} type='button' title='Remove'><span class="remove-image">Remove Image</span></button>
                                    </div>
                                 </div>
                              </div>
                              )						
                              })()}
                              </>
                              ))}
                              </>
                              )
                              }
                              })()}
                           </div>
                           <div class="col-md-10 pl-0">
                            <div class="row">
                              <div class="col-md-4 mb-10 mt-10">
                                 <label>Name</label>
                                 <input type="text" name="name"  defaultValue={list.name} onChange={this.handleSizeChange}  />
                              </div>
                              <div class="col-md-4 mb-10 mt-10">
                                 <label>Mobile No.</label>
                                 <input type="text" name="mobile"   defaultValue={list.mobile}  onChange={this.handleSizeChange}  />
                                 <span class="error" id="mobile_error" ></span>
                              </div>
                              <div class="col-md-4 mb-10 mt-10">
                                 <label>DOB</label>
                                 <DatePicker onChange={this.onChangebirthday} defaultValue={moment(list.birthday, dateFormat)}/>
                              </div>
                              <div class="col-md-4 mb-10 mt-10">
                                 <label>Aadhar Card No</label>
                                 <input type="text" name="aadhar_card_no" defaultValue={list.aadhar_card_no} onChange={this.handleSizeChange}  />
                                 <span class="error" id="aadhar_card_error" ></span>
                              </div>
                              <div class="col-md-4 mb-10 mt-10">
                                 <label>License Id</label>
                                 <input type="text" name="licence"   defaultValue={list.licence}  onChange={this.handleSizeChange}  />
                              </div>
							  <div class="col-md-12 mb-10 mt-10">
                                 <label>Address</label>
                                 <input type="text" name="address" defaultValue={list.address}  onChange={this.handleSizeChange}  />
                              </div>
                           </div>
                        </div>
						</div>
                        <div class="row bb pb-10">
                        <div class="col-md-4 mt-20 mb-10 photos">
                           <label>Driver's License Copy</label>
                           <div className="clearfix mt-10 mb-10">
                              <div class="col m12 s12 center no-padd">
                                 <div class="form-group  mb-10">		
                                    <label></label>				
                                    <input id="file1" type="file" name="file1" accept=".png, .jpg, .jpeg"  onChange={this.handleFileSelectpdf} style={{width: '100%'}}/>
                                 </div>
                                 {list.licence_copy != '' && (<>
                                 <div class="col m12 s12 mb-10 no-padd text-left">
                                   
                                    <a href={list.licence_copy} class="pdf-down" target="_blank">
                                       <FilePdfOutlined />
                                       Click Here To View
                                    </a>
                                 </div>
                                 </>)}
                              </div>
                           </div>
                        </div>
                        <div class="col-md-4 mt-20 mb-10 photos">
                           <label>Driver's Adhaar Card</label>
                           <div className="clearfix mt-10 mb-10">
                              <div class="col m12 s12 center no-padd">
                                 <div class="form-group mb-10">		
                                    <label></label>				
                                    <input id="2" type="file" name="file2" accept=".png, .jpg, .jpeg, .pdf"  onChange={this.handleFileSelectpdf2} style={{width: '100%'}}/>
                                 </div>
                                 {list.aadhar_card != '' && (<>
                                 <div class="col m12 s12 mb-10 no-padd text-left">
                                    
                                    <a href={list.aadhar_card} class="pdf-down" target="_blank">
                                       <FilePdfOutlined />
                                       Click Here To View
                                    </a>
                                    
                                 </div>
                                 </>)}
                              </div>
                           </div>
                        </div>
						</div>
                     </div>
					 <div class="col-md-12 meal  mb-20 center">
                        <Button className="btn btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
                     </div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
         ))}
      </div>
   </div>
</div>
) 
} 
}
export default Index;